<div class="fpk-wrap">

  <!-- Başlık -->
  <div class="fpk-baslik-row">
    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
    </svg>
    <span class="fpk-baslik">{{ baslik() }}</span>
    @if (firmadakiler().length) {
    <span class="fpk-sayi-rozet">{{ firmadakiler().length }} kişi</span>
    }
  </div>

  <!-- Yükleniyor -->
  @if (yukleniyor()) {
  <div class="fpk-yukl">
    <div class="fpk-yukl-dot d1"></div>
    <div class="fpk-yukl-dot d2"></div>
    <div class="fpk-yukl-dot d3"></div>
  </div>
  }

  <!-- Boş durum -->
  @else if (!firmadakiler().length) {
  <div class="fpk-bos">
    <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor"
         stroke-width="1.3" stroke-linecap="round" opacity="0.35">
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
    </svg>
    <span>Şu an kimse firmada değil</span>
  </div>
  }

  <!-- Kişi grid -->
  @else {
  <div class="fpk-grid">
    @for (k of firmadakiler(); track k.kartUid) {
    <div class="fpk-kisi">
      <div class="fpk-avatar">
        @if (k.resimUrl) {
        <img class="fpk-avatar-img" [src]="k.resimUrl" alt="" />
        } @else {
        <span class="fpk-avatar-harf">{{ k.isim?.[0] || '?' }}</span>
        }
        <span class="fpk-avatar-rozet"></span>
      </div>
      <div class="fpk-kisi-isim" [title]="k.isim">{{ k.isim }}</div>
      <div class="fpk-kisi-saat">{{ k.girisSaati }}</div>
      @if (secilenOkuyucular().length > 1) {
      <div class="fpk-kisi-okuyucu" [title]="k.okuyucuKimlik">{{ k.okuyucuIsmi }}</div>
      }
    </div>
    }
  </div>
  }

</div>
